import { render, staticRenderFns } from "./QuestionMarkCircleIcon.vue?vue&type=template&id=3dec537c&scoped=true"
import script from "./QuestionMarkCircleIcon.vue?vue&type=script&lang=js"
export * from "./QuestionMarkCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dec537c",
  null
  
)

export default component.exports